import { createContext } from "react";
import MainStore from "./main_store";
import { MapStore } from "@adactiveasia/adsign-map";

export const rootStoreContext = createContext({
  mapStore: new MapStore(),
  mainStore: new MainStore(),
});
